export const ValidationMode = {
    ValidateAndShow: 'ValidateAndShow',
    ValidateAndHide: 'ValidateAndHide',
    NoValidation: 'NoValidation'
  };